if (!customElements.get("media-gallery")) {
    customElements.define(
        "media-gallery",
        class MediaGallery extends HTMLElement {
            constructor() {
                super();
                this.elements = {
                    liveRegion: this.querySelector('[id^="GalleryStatus"]'),
                    viewer: this.querySelector('[id^="GalleryViewer"]'),
                    thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
                    modal: document.querySelector(
                        ".product-media-modal__content"
                    ),
                };
                this.mql = window.matchMedia("(min-width: 750px)");
                if (!this.elements.thumbnails) return;

                this.elements.viewer.addEventListener(
                    "slideChanged",
                    debounce(this.onSlideChanged.bind(this), 250)
                );
                this.elements.thumbnails
                    .querySelectorAll("[data-target]")
                    .forEach((mediaToSwitch) => {
                        mediaToSwitch
                            .querySelector("button")
                            .addEventListener(
                                "click",
                                this.setActiveMedia.bind(
                                    this,
                                    mediaToSwitch.dataset.target,
                                    false
                                )
                            );
                    });
                if (
                    this.dataset.desktopLayout !== "stacked" &&
                    this.mql.matches
                )
                    this.removeListSemantic();
            }

            onSlideChanged(event) {
                if (!event.detail.currentElement) return;

                let visibleElements = Array.from(
                    this.elements.thumbnails.querySelectorAll("li")
                ).filter((val, key) => {
                    return val.style.display != "none";
                });

                this.setActiveThumbnail(
                    visibleElements[event.detail.currentPage - 1]
                );
            }

            setActiveMedia(mediaId, prepend, activeVariant) {
                const activeMedia = this.elements.viewer.querySelector(
                    `[data-media-id="${mediaId}"]`
                );
                this.elements.viewer
                    .querySelectorAll("[data-media-id]")
                    .forEach((element) => {
                        element.classList.remove("is-active");
                        element.style.display = "block";
                    });
                activeMedia.classList.add("is-active");

                if (prepend) {
                    activeMedia.parentElement.prepend(activeMedia);
                    if (this.elements.thumbnails) {
                        const activeThumbnail =
                            this.elements.thumbnails.querySelector(
                                `[data-target="${mediaId}"]`
                            );
                        activeThumbnail.parentElement.prepend(activeThumbnail);
                    }
                    if (this.elements.viewer.slider)
                        this.elements.viewer.resetPages();
                }
                if (activeVariant) {
                    let sku = activeVariant.sku;

                    let hideElements = (element, key) => {
                        let image = element.querySelector("img");

                        if (image) {
                            let imgSrc = image.getAttribute("src");
                            try {
                                if (
                                    !imgSrc.includes(`__${sku}`) &&
                                    !element.classList.contains("is-active")
                                ) {
                                    element.style.display = "none";
                                    this.elements.thumbnails.querySelector(
                                        `[data-target="${element.dataset.mediaId}"]`
                                    ).style.display = "none";
                                    this.elements.modal.querySelector(
                                        `[data-media-id="${element.dataset.mediaId}"]`
                                    ).style.display = "none";
                                } else {
                                    this.elements.thumbnails.querySelector(
                                        `[data-target="${element.dataset.mediaId}"]`
                                    ).style.display = "block";
                                    this.elements.modal.querySelector(
                                        `[data-media-id="${element.dataset.mediaId}"]`
                                    ).style.display = "block";
                                }
                            } catch (e) {
                                console.warn("Missing image");
                            }
                        }
                    };
                    this.elements.viewer
                        .querySelectorAll("[data-media-id]")
                        .forEach((element, key) => hideElements(element, key));
                }
                this.preventStickyHeader();
                window.setTimeout(() => {
                    if (this.elements.thumbnails) {
                        activeMedia.parentElement.scrollTo({
                            left: activeMedia.offsetLeft,
                        });
                    }
                });
                this.playActiveMedia(activeMedia);

                if (!this.elements.thumbnails) return;
                const activeThumbnail = this.elements.thumbnails.querySelector(
                    `[data-target="${mediaId}"]`
                );
                this.setActiveThumbnail(activeThumbnail);
                this.announceLiveRegion(
                    activeMedia,
                    activeThumbnail.dataset.mediaPosition
                );
            }

            setActiveThumbnail(thumbnail) {
                if (!this.elements.thumbnails || !thumbnail) return;

                this.elements.thumbnails
                    .querySelectorAll("button")
                    .forEach((element) =>
                        element.removeAttribute("aria-current")
                    );
                thumbnail
                    .querySelector("button")
                    .setAttribute("aria-current", true);
                if (this.elements.thumbnails.isSlideVisible(thumbnail, 10))
                    return;

                this.elements.thumbnails.slider.scrollTo({
                    left: thumbnail.offsetLeft,
                });
            }

            announceLiveRegion(activeItem, position) {
                const image = activeItem.querySelector(
                    ".product__modal-opener--image img"
                );
                image.src = image.src;
            }

            playActiveMedia(activeItem) {
                window.pauseAllMedia();
                const deferredMedia =
                    activeItem.querySelector(".deferred-media");
                if (deferredMedia) deferredMedia.loadContent(false);
            }

            preventStickyHeader() {
                this.stickyHeader =
                    this.stickyHeader ||
                    document.querySelector("sticky-header");
                if (!this.stickyHeader) return;
                this.stickyHeader.dispatchEvent(
                    new Event("preventHeaderReveal")
                );
            }

            removeListSemantic() {
                if (!this.elements.viewer.slider) return;
                this.elements.viewer.slider.setAttribute(
                    "role",
                    "presentation"
                );
                this.elements.viewer.sliderItems.forEach((slide) =>
                    slide.setAttribute("role", "presentation")
                );
            }
        }
    );
}
